<template>
  <div class="discussion discussion-facebook discussion-linkedin">
    <div class="detail-event-header">
            <AvatarComponent :typeNetwork="page.network" :urlPicture="infoUser.user && infoUser.user.logoV2 ? infoUser.user.logoV2 : null"></AvatarComponent>
            
            <div class="info">
                <div class="namePage">
                  {{infoUser.name}}
                </div>
                <div class="typeEvent">
                    <p>Discussion privée</p>
                </div>
            </div>
            <div class="selectActionEvent">
                <SelectComponent :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
            </div>
    </div>
    <ul v-if="!isLoading && Object.keys(infoConversation).length && Object.keys(infoUser).length && messages && messages.data" class="discussion-order scrollable" ref="discussionScrool">
      <li v-for="(discut, key) in messages.data.messengerMessagesBySyncToken.elements" :key="key">
          <div v-if="!messages.data[key+1] || new Date(discut.deliveredAt).getTime() - new Date(messages.data[key+1].deliveredAt).getTime() > 900000" class="date">{{ dateFormat(discut.deliveredAt) }}</div>

          <div v-if="!discut.sender.backendUrn.includes('urn:li:pageMailbox:')" class="message-received">
           
            <div class="message-received-content">
              <div class='message-received-content-text text'>
               
                <p>{{ discut.body ? discut.body.text : '' }}</p>
           
                <!-- <img v-if="discut.renderContent && discut.renderContent.length && discut.renderContent[0].vectorImage"
                  class="message-received-content-image"
                  :src="discut.renderContent[0].vectorImage.rootUrl"
                /> -->
                <Tooltip :text="$t('dash.inbox.content.show-media.description.linkedin')" position="top" v-if="discut.renderContent && discut.renderContent.length">
                  <a class="show-media" :href="event.data.conversationUrl.replace('/messaging/', `/company/${page.network_id}/admin/inbox/`)" target="_blank">
                    {{ $t('dash.inbox.content.show-media.title.linkedin') }}
                  </a>
                </Tooltip>
               
                <div class="containerReactions" v-if="discut.reactionSummaries && discut.reactionSummaries.length">
                  <div class="reactions">
                    <i v-for="(reaction, keyReaction) in discut.reactionSummaries" :key="keyReaction">{{ reaction.emoji }}</i>
                    <!-- <span class="count-reaction">{{ reaction.count }}</span> -->
                    <!-- <i class="fa-regular fa-face-smile"></i> -->
                  </div>
                </div>

              </div>
              <!-- <i class="fa-solid fa-ellipsis-vertical"></i> -->
            
            </div>

            <div class="container-actions-message"></div>
            
          </div> 

          <div v-else class="message-sent">
            <div class="message-sent-content">
              <!-- <ContextMenu :options="[{label: $t('dash.button.delete'), name : 'deleteComment'}]" :id="discut.id" v-on:clickOption="clickOptionMessage">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </ContextMenu> -->
              <div class='message-sent-content-text' :class="{'text':discut.body && discut.body.text && discut.body.text.length}">
                
                <p v-if="discut.body && discut.body.text && discut.body.text.length">{{ discut.body.text }}</p>
                               
                <Tooltip :text="$t('dash.inbox.content.show-media.description.linkedin')" position="top" v-if="discut.renderContent && discut.renderContent.length">
                  <a class="show-media" :href="event.data.conversationUrl.replace('/messaging/', `/company/${page.network_id}/admin/inbox/`)" target="_blank">
                    {{ $t('dash.inbox.content.show-media.title.linkedin') }}
                  </a>
                </Tooltip>

                <div class="containerReactions" v-if="discut.reactionSummaries && discut.reactionSummaries.length">
                  <div class="reactions">
                    <i v-for="(reaction, keyReaction) in discut.reactionSummaries" :key="keyReaction">{{ reaction.emoji }}</i>
                    <!-- <span class="count-reaction">{{ reaction.count }}</span> -->
                    <!-- <i class="fa-regular fa-face-smile"></i> -->
                  </div>
                </div>
              
              </div>     
            </div>

        

              <!-- <div class="container-actions-message" >
                <div class="status" v-if="discut.tags.data[2].name == 'echec' || discut.tags.data[1].name == 'echec'">Echec de l'envoi</div>
                <div class="status" v-else-if="getIndexLastMessageSend == key">Envoyé</div>
              </div> -->
            
          </div>

         
      </li>

      <!-- <li class="loading-other-message">
        <div v-if="messages.paging.next" class="util-loader"></div>
        <p v-if="messages.paging.next">Chargement des anciens messages</p>
        <p v-else>Debut de la conversation</p>
      </li> -->
    </ul>
    <ul v-else class="discussion-order scrollable">
      <li v-for="index in 8" :key="index">
          
          <div v-if="Math.random() > 0.5" class="message-received content-loading">
           <div class="message-received-content">
            <div class='message-received-content-text text'>
               <p>{{ 'w'.repeat(5+Math.random()*100) }}</p>
             </div>
           </div>
           <div class="container-actions-message"></div>
          </div> 
          <div v-else class="message-sent content-loading">
            <div class="message-sent-content">

             
              <div class='message-sent-content-text text'>    
                <p>{{ 'w'.repeat(5+Math.random()*100) }}</p>            
              </div>     
            </div>
            <div class="container-actions-message"></div>
            
          </div>
      </li>
    </ul>

    <!-- send message -->
    <FormSendMessage :acceptTypeMedia="'image/*'" v-on:onSubmitMessage="onSubmitMessage"></FormSendMessage>
    
  </div>

  <!-- savoir si c est un message recus ou envoyé  {{ discut.from.name }} {{ page.name }} sont egal. -->
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'



import 'emoji-mart-vue-fast/css/emoji-mart.css'
import ContextMenu from '../contextMenu/contextMenuInit.vue'
import FormSendMessage from './FormSendMessage'
import AvatarComponent from '../utils/avatar.vue'
import SelectComponent from '../utils/select.vue'
import Tooltip from './../tooltip/tooltipInit'

export default {
  name: 'component-discussion-linkedin',

  mixins: [Moderation],

  components: {
    Tooltip,
    ContextMenu,
    FormSendMessage,
    AvatarComponent,
    SelectComponent
  },

  props: {

    messages : Object,
    infoConversation : Object,
    infoUser : Object,
    event: Object,
    page: Object,
    isLoading : {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      showEmojiPicker: false,
      message: null,
      user: null,
      url: [],
      fileInput: [], // Store our uploaded file
      fileInputParesed: []
    }
  },

  mounted() {
    if(this.$refs.discussionScrool)
      this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    if(this.$refs.discussionScrool)
      this.$refs.discussionScrool.removeEventListener('scroll', this.handleScroll);
  },

  methods: {

    changeStatus(status){
      this.$emit('changeStatus', status)
    },

    onChange() {
      this.fileInput = [...this.$refs.file.files]
      console.log('this.$refs.file', this.$refs.file)
    },
    
    previewFiles(e) {
      console.log('nombre d images', e.target.files.length)
      console.log(e.target.files)
      for (var file of e.target.files) {
        this.url.push(URL.createObjectURL(file))
      }
      console.log(this.url)
    },

    async onSubmitMessage(formData,filesUrl = []) {

      formData.append('pageMailbox', this.infoConversation.conversationParticipants.find(p => p.backendUrn.includes('urn:li:pageMailbox:')).backendUrn)

      if (formData.get('message')) {
        let newMessage = this.messages.data.messengerMessagesBySyncToken.elements.find(m => m.sender.backendUrn.includes('urn:li:pageMailbox:'))
        newMessage.deliveredAt = new Date().toISOString()
        newMessage.body.text = formData.get('message')
        this.messages.data.messengerMessagesBySyncToken.elements = [...this.messages.data.messengerMessagesBySyncToken.elements, newMessage]
      } 

      // if(formData.get('file[]') && filesUrl.length > 0) {
      //   filesUrl.forEach(url => {
      //     console.log("url",url)
      //     this.messages.data = [{
      //       "created_time":new Date().toISOString(),
      //       "from":  this.infoConversation.participants.data.find(participant => participant.id == this.page.network_id),
      //       "message": "",
      //       "attachments":{
      //         "data":[
      //           {
      //             "image_data":{
      //               "url":url,
      //             }
      //           }
      //         ],
      //       },
      //       "id":"",
      //       "tags":{"data":[{"name":"inbox"},{"name":""},{"name":"source:web"}]},
      //       "to":{
      //         "data":[{"name": this.infoUser.first_name+" "+this.infoUser.last_name,"email":this.infoUser.id+"@facebook.com","id": this.infoUser.id}]
      //     }},...this.messages.data]
      //   });    
      // }
      
      let recipientId = this.infoConversation.entityUrn
      
      let result = await this.sendMessage(this.page, recipientId, formData)
      console.log('result', result)

      // let idNewPost = this.messages.data.messengerMessagesBySyncToken.elements.length
      // if (result.body.success) {
      //   this.messages.data.messengerMessagesBySyncToken.elements[idNewPost - 2].tags.data[1].name = "sent"
      //   if (filesUrl.length > 0 && formData.get('message'))  this.messages.data.messengerMessagesBySyncToken.elements[idNewPost - 1].tags.data[1].name = "sent"
      // }else{
      //   this.messages.data.messengerMessagesBySyncToken.elements[idNewPost - 2].tags.data[1].name = "echec"
      //   if (filesUrl.length > 0 && formData.get('message'))  this.messages.data.messengerMessagesBySyncToken.elements[idNewPost - 1].tags.data[1].name = "echec"
      // }
    },

    // clickOptionMessage(id, nameOption) {
    //   switch (nameOption) {
    //     case 'deleteMessage':

    //     break
    //   }
    // },

    dateFormat(dateMessage) {
      if (typeof dateMessage !== "object") {
        dateMessage = new Date(dateMessage)
      }
      let date = new Date()
      let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

      if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
          return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
          
      }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
          return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
      }else{
          return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
      }
    },

    handleScroll(e) {
      if (e.target.scrollHeight - (e.target.offsetHeight - e.target.scrollTop) < 20 && this.$refs.discussionScrool) {
        this.$refs.discussionScrool.removeEventListener('scroll', this.handleScroll);
        this.getOtherMessage()
      }
    },

    async getOtherMessage() {
      if (this.messages && this.messages.paging && this.messages.paging.next) {
        let request = await this.$http.get(this.messages.paging.next, {}).then(res => res, err => err);
        // console.log(request.body,equest.body.datarequest.body.paging)
        if (request.body && request.body.data) {
          if (request.body.paging) this.messages.paging = request.body.paging
          let newArray = (this.messages.data).concat(request.body.data)
          this.messages.data = newArray
        }

        if (request.body.paging && request.body.paging.next && this.$refs.discussionScrool) {
          this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
        }else{
          this.messages.paging = {}
        }
      }
    },
  },

  computed: {
      getIndexLastMessageSend() {
        return this.messages.data.findIndex((discut) => (discut.tags.data[2] && discut.tags.data[2].name == 'sent') || (discut.tags.data[1] && discut.tags.data[1].name == 'sent'))
      }
  },

  watch: {
    event() {
      if (this.$refs.discussionScrool) {
        this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
      }
    }
  }
}
</script>